import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type MegaMenuItem = { label: string; to: string; icon?: string; desc?: string };
export type MegaMenuGroup = { title: string; items: MegaMenuItem[] };
export type MegaMenuCategory = {
  label: string;
  desc: string;
  icon?: string;
  groups: MegaMenuGroup[];
};
export type MegaMenuConfig = {
  label?: string;
  featured?: { title: string; desc: string; to: string };
  categories: MegaMenuCategory[];
};

export function useMegaMenu(key: string) {
  return useQuery({
    queryKey: ["mega-menu", key],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("mega_menus")
        .select("config")
        .eq("key", key)
        .maybeSingle();
      if (error) throw error;
      return (data?.config as MegaMenuConfig) ?? null;
    },
    staleTime: 60_000,
  });
}
